function TimerOffIcon() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.3667 3.9834H32.3667V10.6501H52.3667V3.9834Z"
        fill="#B21212"
      />
      <path
        d="M42.3667 20.6501C55.2667 20.6501 65.7 31.0834 65.7 43.9834C65.7 47.1167 65.0667 50.0834 63.9667 52.8167L68.9667 57.8167C71.1333 53.6834 72.3667 48.9834 72.3667 43.9834C72.3667 36.9167 69.9 30.4167 65.8 25.2834L70.5333 20.5501C69.1 18.8501 67.5333 17.2501 65.8333 15.8501L61.1 20.5834C55.9333 16.4501 49.4333 13.9834 42.3667 13.9834C37.3667 13.9834 32.6667 15.2167 28.5333 17.3834L33.5333 22.3834C36.2667 21.2834 39.2333 20.6501 42.3667 20.6501Z"
        fill="#B21212"
      />
      <path
        d="M39.0333 27.8834L45.7 34.5501V27.3167H39.0333V27.8834Z"
        fill="#B21212"
      />
      <path
        d="M11.7333 10.0167L7 14.7167L18.3333 26.0501C14.6 31.0501 12.3667 37.2501 12.3667 43.9834C12.3667 60.5501 25.7667 73.9834 42.3667 73.9834C49.1 73.9834 55.3 71.7501 60.3 68.0167L68.3 76.0167L73 71.3167L11.7333 10.0167ZM42.3667 67.3167C29.4667 67.3167 19.0333 56.8834 19.0333 43.9834C19.0333 39.0834 20.5333 34.5501 23.1 30.8167L55.5333 63.2501C51.8 65.8167 47.2667 67.3167 42.3667 67.3167Z"
        fill="#B21212"
      />
    </svg>
  );
}

export default TimerOffIcon;
